{
	"content": {
		"declarationDetailsSection": {
			"title": "Детайли на декларацията",
			"description": "За създаване на декларацията са необходими името на клиента, адресът и държавата на притежателя на декларацията. Информацията не може да бъде променяна след това.",
			"customerLabel": "Клиентски акаунт"
		},
		"provideDeclarationsDetailsSection": {
			"title": "Предоставяне на детайли на декларацията",
			"alertDescription": "Информацията, която предоставяте, ще бъде записана трайно в декларацията и не може да бъде променяна след това.",
			"projectLabel": "Референция на проект",
			"companyNameLabel": "Име на компания",
			"streetLabel": "Улица",
			"zipCodeLabel": "Пощенски код",
			"cityLabel": "Град",
			"countryLabel": "Държава"
		}
	},
	"summary": {
		"title": "Обобщение",
		"declarationTypeTitle": "Тип декларация",
		"customerProjectTitle": "Проект на клиента",
		"internalProjectOrProductTitle": "Вътрешен проект / продукт",
		"projectReferenceTitle": "Референция на проект",
		"materialHeaderTitle": "Материал",
		"quantityHeaderTitle": "Количество ({{unit}})",
		"totalTransferableCarbonReductionsTitle": "Разпределими въглеродни редукции ({{unit}})",
		"nonTransferableCarbonReductionTitle": "Неразпределими въглеродни редукции ({{unit}})"
	},
	"errorMessages": {
		"projectRequired": "Референцията на проекта е задължителна",
		"companyNameRequired": "Името на компанията е задължително",
		"streetRequired": "Улицата е задължителна",
		"zipCodeRequired": "Пощенският код е задължителен",
		"cityRequired": "Градът е задължителен",
		"countryRequired": "Държавата е задължителна",
		"customerRequired": "Клиентът е задължителен"
	},
	"reviewDeclarationDetailsModal": {
		"title": "Преглед на обобщението на декларацията",
		"description": "Моля, прегледайте въведените данни за евентуални грешки.",
		"alertDescription": "Информацията, която предоставихте, ще бъде записана трайно в декларацията и не може да бъде променяна след това.",
		"typeSectionTitle": "1. Тип",
		"declarationTypeLabel": "Тип декларация",
		"customerProjectTitle": "Проект на клиента",
		"internalProjectOrProductTitle": "Вътрешен проект / продукт",
		"projectReferenceLabel": "Референция на проект",
		"materialSectionTitle": "2. Материал",
		"materialHeaderTitle": "Материал",
		"quantityHeaderTitle": "Количество ({{unit}})",
		"totalCarbonReductionsLabel": "Общи въглеродни редукции ({{unit}})",
		"declarationSectionTitle": "3. Декларация",
		"companyNameLabel": "Име на компания",
		"streetLabel": "Улица",
		"zipCodeLabel": "Пощенски код",
		"cityLabel": "Град",
		"countryLabel": "Държава",
		"backTitle": "Назад",
		"submitTitle": "Да, всичко е вярно"
	},
	"submitTitle": "Създай декларация",
	"backTitle": "Назад"
}
